<template>
  <div class="loading">
    <div class="inner">
      <van-loading color="#fff" size="24px">{{ text }}</van-loading>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    text: {
      type: String,
      default: '加载中...',
    },
  },
}
</script>
<style lang="less" scoped>
.loading {
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  background-color: rgba(255, 255, 255, 0.1);
  z-index: 1001;
  .inner {
    position: absolute;
    top: 50%;
    left: 50%;
    background-color: rgba(0, 0, 0, 0);
    color: #fff;
    z-index: 1001;
    transform: translate(-50%, -50%);
    padding: 15px 20px;
    background: rgba(65, 72, 93, 0.77);
    border-radius: 4px;
    .van-loading__text {
      color: #fff;
    }
  }
}
</style>
